<template>
  <div class="techerDivDisplay">
    <common-title-widge
      :title="title"
      :desc="desc"
      :bgFont="bgFont"
      class="teacher_title"
    ></common-title-widge>
    <div v-if="imgUrls.length > 0">
      <common-techer-display-widge :imgs="imgUrls" class="teacher_desc">
      </common-techer-display-widge>
    </div>
  </div>
</template>

<script>
import commonTitleWidge from "../asserts/common/components/commonTitleWidge";
import commonTecherDisplayWidge from "../../common/components/techerDisplayWidge";
export default {
  components: {
    commonTitleWidge,
    commonTecherDisplayWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
    imgUrls: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "../asserts/scss/techerDisplayWidge.scss";
</style>
